// extracted by mini-css-extract-plugin
export default {"checkmark-list-item":"CheckmarkListItem_checkmark-list-item__zl7O4","checkmark-list-item__icon":"CheckmarkListItem_checkmark-list-item__icon__sE60o"};